var _rect, _path, _circle, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 120,
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 25,
    width: 160,
    height: 100,
    rx: 12,
    fill: "#EFFFFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 105c20-30 35-40 55-30 20 10 35-35 65-28",
    stroke: "#00C2A8",
    strokeWidth: 3,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 47,
    r: 6,
    fill: "#00C2A8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 40,
    width: 50,
    height: 10,
    rx: 5,
    fill: "#CFF7F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 40,
    width: 50,
    height: 10,
    rx: 5,
    fill: "#CFF7F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.7d2b05aa3fd7df67271a4cbf5f03566b.svg";
export { ForwardRef as ReactComponent };